import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';

import store from 'Redux/store';
import { postEmail, EMAIL_SUBSCRIBE, EMAIL_ERROR } from 'Redux/ducks/email-subscribe';

import 'Components/ProductOffers/EmailSubscribeOffer.scss';

const context = 'nlmodule_productoffer';

const EmailSubscribeOffer = ({
  auth,
  emailSubscribe,
}) => {
  const [email, setEmail] = useState('');

  const intl = useIntl();

  // Will check if the user subed in the last 24 hours
  const productSubscribedLast24hours = (Date.now() - localStorage.getItem('productSubscribedDate')) <= 1 * 24 * 60 * 60 * 1000;

  const handleChange = (event) => {
    event.preventDefault();
    setEmail(event.target.value, false);
  };

  const optinEmail = (event, emailPassed, optin) => {
    event.preventDefault();
    store.dispatch(postEmail(emailPassed, context, optin, true));
  };

  const handleSubmit = (event) => {
    if (auth.authenticated) {
      return optinEmail(event, auth.email, true);
    }
    return optinEmail(event, email, true);
  };

  useEffect(() => {
    if (emailSubscribe.currentState === EMAIL_SUBSCRIBE && emailSubscribe.context === 'nlmodule_productoffer') {
      localStorage.setItem('productSubscribedDate', Date.now());
    }
  }, [emailSubscribe.currentState, emailSubscribe.context]);

  return (
    <>
      {
        productSubscribedLast24hours ?
          <React.Fragment>
            <div className="email-subscribe-banner">
              <div className="text-container">
                <div className="text-heading" style={{ color: '#4caf50' }}>
                  <FontAwesomeIcon icon={faCircleCheck} className="text-icon" style={{ color: '#4caf50' }} />
                  <FormattedMessage id="offer-banner.text-heading-success" defaultMessage="You've been successfully subscribed!" />
                </div>
                <div className="text-subtext">
                  <FormattedMessage id="offer-banner.text-subtext-success" defaultMessage="Thanks for subscribing! Stay tuned for exciting updates and exclusive content." />
                </div>
              </div>
            </div>
          </React.Fragment> :
          <React.Fragment>
            <div className="email-subscribe-banner">
              <div className="text-container">
                <div className="text-heading">
                  <FontAwesomeIcon icon={faEnvelope} className="text-icon" />
                  <FormattedMessage id="offer-banner.text-heading" defaultMessage="Sign-up for Fanatical's Newsletter!" />
                </div>
                <div className="text-subtext">
                  <FormattedMessage id="offer-banner.text-subtext" defaultMessage="Unlock special gaming deals, limited-time bundles, and more — sign up today!" />
                </div>
              </div>
              <div className="input-container" id={`emailsignup-${context}`}>
                <div className="input-container">
                  <React.Fragment>
                    <form onSubmit={handleSubmit}>
                      <div className="input-group">
                        <input
                          required
                          placeholder={intl.formatMessage({ id: 'email-subscribe-nav.placeholder', defaultMessage: 'Enter your email' })}
                          className={classNames(auth.authenticated && 'd-none', 'form-control')}
                          type="email"
                          name="email"
                          title="Enter your email address"
                          enterKeyHint="send"
                          aria-label="email"
                          value={auth.email}
                          onChange={handleChange}
                        />
                        <span className="input-group-append">
                          <button className="btn btn-primary" type="submit">
                            <FormattedMessage
                              id="subscribe.modal.button"
                              defaultMessage="Subscribe"
                            />
                          </button>
                        </span>
                        {emailSubscribe.currentState === EMAIL_ERROR && <div style={{ color: '#f44336', marginTop: '0.2rem' }}>An error has occured please try again</div>}
                      </div>
                    </form>
                  </React.Fragment>
                </div>
              </div>
            </div>
          </React.Fragment>
      }
    </>
  );
};

EmailSubscribeOffer.propTypes = {
  auth: PropTypes.shape({}),
  emailSubscribe: PropTypes.shape({}),
};

EmailSubscribeOffer.defaultProps = {
  auth: {},
  emailSubscribe: {},
};

const mapStateToProps = ({ auth, emailSubscribe }) => ({ auth, emailSubscribe });

export default connect(mapStateToProps)(EmailSubscribeOffer);
